export default "__VITE_ASSET__04929dd2__"